module.exports = __webpack_public_path__ + "img/TG.a3f7312e.png";